var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("UiButton", {
        attrs: {
          buttonText: "New Conversation",
          id: "newConversation",
          variant: "black",
          size: _vm.size,
        },
        on: {
          click: function ($event) {
            _vm.newConversationDialog = true
          },
        },
        scopedSlots: _vm._u([
          {
            key: "icon",
            fn: function () {
              return [_c("InboxAdd", { staticClass: "w-4 h-4" })]
            },
            proxy: true,
          },
          {
            key: "hover-icon",
            fn: function () {
              return [_c("InboxAddHover", { staticClass: "w-4 h-4" })]
            },
            proxy: true,
          },
        ]),
      }),
      _c("CreateConversationModal", {
        attrs: {
          companyId: _vm.companyId,
          currentUserId: _vm.currentUserId,
          currentUserRole: _vm.currentUserRole,
        },
        on: { createConversation: (v) => _vm.$emit("createConversation", v) },
        model: {
          value: _vm.newConversationDialog,
          callback: function ($$v) {
            _vm.newConversationDialog = $$v
          },
          expression: "newConversationDialog",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }